module.exports = {
  path: '../../../../../static/faces',
  obj: {
    '[):]': 'ee_1.png',
    '[:D]': 'ee_2.png',
    '[;)]': 'ee_3.png',
    '[:-o]': 'ee_4.png',
    '[:p]': 'ee_5.png',
    '[(H)]': 'ee_6.png',
    '[:@]': 'ee_7.png',
    '[:s]': 'ee_8.png',
    '[:$]': 'ee_9.png',
    '[:(]': 'ee_10.png',
    '[:\'(]': 'ee_11.png',
    '[:|]': 'ee_18.png',
    '[(a)]': 'ee_13.png',
    '[8o|]': 'ee_14.png',
    '[8-|]': 'ee_15.png',
    '[+o(]': 'ee_16.png',
    '[<o)]': 'ee_12.png',
    '[|-)]': 'ee_17.png',
    '[*-)]': 'ee_19.png',
    '[:-#]': 'ee_20.png',
    '[:-*]': 'ee_22.png',
    '[^o)]': 'ee_21.png',
    '[8-)]': 'ee_23.png',
    '[(|)]': 'ee_24.png',
    '[(u)]': 'ee_25.png',
    '[(S)]': 'ee_26.png',
    '[(*)]': 'ee_27.png',
    '[(#)]': 'ee_28.png',
    '[(R)]': 'ee_29.png',
    '[({)]': 'ee_30.png',
    '[(})]': 'ee_31.png',
    '[(k)]': 'ee_32.png',
    '[(F)]': 'ee_33.png',
    '[(W)]': 'ee_34.png',
    '[(D)]': 'ee_35.png'
  },
  reverseObj: {
    'ee_1': '[):]',
    'ee_2': '[:D]',
    'ee_3': '[;)]',
    'ee_4': '[:-o]',
    'ee_5': '[:p]',
    'ee_6': '[(H)]',
    'ee_7': '[:@]',
    'ee_8': '[:s]',
    'ee_9': '[:$]',
    'ee_10': '[:(]',
    'ee_11': '[:\'(]',
    'ee_12': '[<o)]',
    'ee_13': '[(a)]',
    'ee_14': '[8o|]',
    'ee_15': '[8-|]',
    'ee_16': '[+o(]',
    'ee_17': '[|-)]',
    'ee_18': '[:|]',
    'ee_19': '[*-)]',
    'ee_20': '[:-#]',
    'ee_22': '[:-*]',
    'ee_21': '[^o)]',
    'ee_23': '[8-)]',
    'ee_24': '[(|)]',
    'ee_25': '[(u)]',
    'ee_26': '[(S)]',
    'ee_27': '[(*)]',
    'ee_28': '[(#)]',
    'ee_29': '[(R)]',
    'ee_30': '[({)]',
    'ee_31': '[(})]',
    'ee_32': '[(k)]',
    'ee_33': '[(F)]',
    'ee_34': '[(W)]',
    'ee_35': '[(D)]'
  }
}



// WEBPACK FOOTER //
// ./src/config/emoji.js